const orderStateType = {
  submitOrder: 0, //提交订单状态
  waitingOrder: 1, //等待商家接单
  waitingPay: 2, //等待买家支付
  waitingGoods: 3, //待收货
  orderCompletion: 4 //订单完成
}

export default {
  active: 0,
  // 是否写入芯片状态
  isWriteState: false,
  //nfc
  nfcReadTxt: '',
  nfcWriteTxt: '',
  lastChipUid: {},
  userGeo: {},
  //底部导航
  bmTab: 1,
  scanindex: 0,
  myindex: 0,
  imgindex: 0,
  imgsindex: 1,
  img: '',
  //谈宝导航
  talkbaoindex: 0,
  //逛逛导航
  guangguangindex: 0,
  //印记导航
  imprintindex: 0,
  //印记关注导航
  imprintFocusonIndex: 0,

  //弹出窗
  showUpdateNum: false,
  //我抢到的弹出框文本
  iGetSalesNum: 0,
  //添加备注弹出框文本
  addRemarkText: '',
  //添加备注的店铺
  addRemarkObj: {},

  //我抢到的修改商品弹出框的商品
  iGetUpdateSalesNum: {},

  //返回等待商家接单
  backWaitOrder: false,
  //弹窗框的类型
  focusAddRemark: '',
  //谈宝发布
  showPublish: false,
  // 购物车详情页还是订单详情页
  isCart: 0,
  //用户ID
  id: undefined,
  //店铺详情
  boothStoreDetail: {},
  //订单主键ID
  orderKeyId: 0,
  // 模板库Id
  templateLibraryId: 0,
  //订单状态
  orderStateObj: {
    orderState: orderStateType.submitOrder,
  },
  //视频播放
  videoShow: false,
  videoSrc: '',

  //首页弹框
  homePop: true,
  // 刚进页面是密码弹窗
  passwordStatus: false,
  // swiperNum: localStorage.getItem('swiperNum')
  // 店铺id
  storeId: JSON.parse(localStorage.getItem('storeId')),
  guangguangIndex:0,

  hintVisible: false,


}



// WEBPACK FOOTER //
// ./src/store/state.js